import React, { useState, useEffect } from "react";
import styled from "styled-components";
import OptimizedImage from "./OptimizedImage";

// Import images from home directory
import img1 from "../assets/home/micheal.jpg";
import img2 from "../assets/home/cookie.png";
import img3 from "../assets/home/gizmo.jpg";
import img4 from "../assets/home/box.jpg";
import img5 from "../assets/home/lulu.jpg";
import img6 from "../assets/home/james.png";
import img7 from "../assets/home/nini.jpg";
import img8 from "../assets/home/fin.jpg";
import img9 from "../assets/home/karam.jpg";
import img10 from "../assets/home/mike.jpg";
import img11 from "../assets/home/tuez.jpg";
import img12 from "../assets/home/sungmo.jpg";
import img13 from "../assets/home/berzan.jpg";
import img14 from "../assets/home/bill.jpg";
import img15 from "../assets/home/keone.jpg";

// WebP versions (will be generated by compression script)
import img1WebP from "../assets/webp/home/micheal.webp";
import img2WebP from "../assets/webp/home/cookie.webp";
import img3WebP from "../assets/webp/home/gizmo.webp";
import img4WebP from "../assets/webp/home/box.webp";
import img5WebP from "../assets/webp/home/lulu.webp";
import img6WebP from "../assets/webp/home/james.webp";
import img7WebP from "../assets/webp/home/nini.webp";
import img8WebP from "../assets/webp/home/fin.webp";
import img9WebP from "../assets/webp/home/karam.webp";
import img10WebP from "../assets/webp/home/mike.webp";
import img11WebP from "../assets/webp/home/tuez.webp";
import img12WebP from "../assets/webp/home/sungmo.webp";
import img13WebP from "../assets/webp/home/berzan.webp";
import img14WebP from "../assets/webp/home/bill.webp";
import img15WebP from "../assets/webp/home/keone.webp";

const ImageContainer = styled.div`
  width: 90%;
  height: 90%;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  background-color: ${(props) => props.theme.body};
  margin: auto;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 20px;
  overflow: hidden;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 64em) {
    &:hover {
      transform: scale(1.01);
    }
  }
`;

const ImageCarousel = () => {
  const images = [
    { src: img1, webp: img1WebP, alt: "Micheal" },
    { src: img2, webp: img2WebP, alt: "Cookie" },
    { src: img3, webp: img3WebP, alt: "Gizmo" },
    { src: img4, webp: img4WebP, alt: "Box" },
    { src: img5, webp: img5WebP, alt: "Lulu" },
    { src: img6, webp: img6WebP, alt: "James" },
    { src: img7, webp: img7WebP, alt: "Nini" },
    { src: img8, webp: img8WebP, alt: "Fin" },
    { src: img9, webp: img9WebP, alt: "Karam" },
    { src: img10, webp: img10WebP, alt: "Mike" },
    { src: img11, webp: img11WebP, alt: "Tuez" },
    { src: img12, webp: img12WebP, alt: "Sungmo" },
    { src: img13, webp: img13WebP, alt: "Berzan" },
    { src: img14, webp: img14WebP, alt: "Bill" },
    { src: img15, webp: img15WebP, alt: "Keone" },
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 600);

    return () => clearInterval(interval);
  }, [images.length]);

  const currentImage = images[currentImageIndex];

  return (
    <ImageContainer>
      <ImageWrapper>
        <OptimizedImage
          src={currentImage.src}
          webpSrc={currentImage.webp}
          alt={currentImage.alt}
          loading="eager" // First image should load immediately
          placeholder="Loading NFT..."
          errorText="Failed to load NFT image"
          height="400px"
          borderRadius="20px"
        />
      </ImageWrapper>
    </ImageContainer>
  );
};

export default ImageCarousel;
